// Select all dropdown containers on the page
const languageDropdowns = document.querySelectorAll('.language-dropdown');

languageDropdowns.forEach(dropdown => {
    const languageItems = dropdown.querySelectorAll('.dropdown-list li');
    const dropdownBtn = dropdown.querySelector('.dropdown-btn');
    const currentLanguage = dropdown.querySelector('.currentLanguage');
    const currentFlag = dropdown.querySelector('.currentFlag');
    const dropdownList = dropdown.querySelector('.dropdown-list');
    const dropdownArrow = dropdown.querySelector('.arrow');

    // Function to update the selected language on the button
    function updateSelectedLanguage(languageName, flagSrc) {
        currentLanguage.textContent = languageName; // Update the button text with language name
        currentFlag.src = flagSrc; // Update the flag image on the button
    }

    // Check if there is a selected language and flag in localStorage
    const savedLanguage = localStorage.getItem(`selectedLanguage-${dropdown.dataset.dropdownId}`);
    const savedFlag = localStorage.getItem(`selectedFlag-${dropdown.dataset.dropdownId}`);

    if (savedLanguage && savedFlag) {
        updateSelectedLanguage(savedLanguage, savedFlag);
    }

    languageItems.forEach(item => {
        item.addEventListener('click', function () {
            const selectedLang = this.getAttribute('data-lang');
            const flagSrc = this.getAttribute('data-flag-src');
            const url = this.getAttribute('data-url');

            // Save the selected language and flag in localStorage using a unique key for each dropdown
            localStorage.setItem(`selectedLanguage-${dropdown.dataset.dropdownId}`, selectedLang);
            localStorage.setItem(`selectedFlag-${dropdown.dataset.dropdownId}`, flagSrc);

            // Update the dropdown button with the selected language and flag
            updateSelectedLanguage(selectedLang, flagSrc);

            // Redirect to the selected language URL
            window.location.href = url;
        });
    });

    // Toggle the dropdown visibility when the button is clicked
    dropdownBtn.addEventListener('click', function () {
        dropdownList.classList.toggle('show');
        dropdownArrow.classList.toggle('rotate');  // Rotate the arrow on open
    });

    // Close the dropdown when clicking outside
    document.addEventListener('click', function (event) {
        // Check if the click is outside the dropdown button or the dropdown list
        if (!dropdownBtn.contains(event.target) && !dropdownList.contains(event.target)) {
            dropdownList.classList.remove('show'); // Hide the dropdown
            dropdownArrow.classList.remove('rotate'); // Reset the arrow rotation
        }
    });

    // Prevent closing when clicking inside the dropdown button or list
    dropdownList.addEventListener('click', function (event) {
        event.stopPropagation(); // Prevent click from propagating to document
    });
});
